import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { cn } from '@/lib/utils'
import { LogoMark } from '@/components/generals/logo'

interface AppImageProps {
    src: string | null | undefined
    alt: string | null | undefined
    sizes: string
    className?: string
    preload?: boolean
}

const OPTIMIZABLE_HOST = /^https:\/\/[a-z0-9-]+\.cdn\.modulify\.website\//i

const isOptimizable = (src: string): boolean => src.startsWith('/') || OPTIMIZABLE_HOST.test(src)

// Renders a database or storage image inside a positioned parent (fill mode).
// Images from this site's storage are resized and converted automatically; any other
// address the CMS might hold is shown as-is, and a missing image becomes a branded panel.
const AppImage: FC<AppImageProps> = ({ src, alt, sizes, className, preload = false }): ReactNode => {
    if (!src) {
        return (
            <div
                role='img'
                aria-label={alt ?? 'Imagen no disponible'}
                className='absolute inset-0 flex items-center justify-center bg-graphite text-brass/40'
            >
                <LogoMark className='size-12' />
            </div>
        )
    }

    return (
        <Image
            src={src}
            alt={alt ?? ''}
            fill
            sizes={sizes}
            preload={preload}
            unoptimized={!isOptimizable(src)}
            className={cn('object-cover', className)}
        />
    )
}

export default AppImage
